import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { BreakpointObserver } from '@angular/cdk/layout';
import { Observable, Subscription } from 'rxjs';
import { MediaQuery } from '@bca-core/models/_enums';
import { map } from 'rxjs/operators';

@Component({
  selector: 'bca-tool-tip',
  templateUrl: 'tool-tip.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToolTipComponent {
  @Input() textOrKey: string;
  isMobile$: Observable<boolean>;
  mobileSubscription: Subscription;
  show: boolean;

  constructor(private _breakPoint: BreakpointObserver) {
    this.isMobile$ = this._breakPoint
      .observe(MediaQuery.MAX_WIDTH_1024)
      .pipe(map(({ matches }) => matches));
  }
  checkMobile(action: boolean): void {
   this.mobileSubscription =  this.isMobile$.subscribe(res =>  {
      if (!res && action) this.show = true ;
      else if (!res && !action) this.show = false;
      else this.show = false;
      this.destroy();
    });
  }
  destroy(): void {
    if (this.mobileSubscription) this.mobileSubscription.unsubscribe();
  }
}
